import { Stack } from '@mui/material';
import ColoredAvatar from 'core/components/ColoredAvatar';
import { getFullName } from 'core/utils/commonUtils';
import PageHeaderText from 'layout/pages/PageHeaderText';
import PageHeaderWrapper from 'layout/pages/PageHeaderWrapper';
import type { User } from 'models/user/user';
import type { FC } from 'react';

const ProfileEditPageHeader: FC<UserEditPageHeaderProps> = ({ user }) => {
  const userName = getFullName(user);

  return (
    <PageHeaderWrapper>
      <Stack direction={'row'} spacing={2} sx={{ alignItems: 'center' }}>
        <ColoredAvatar alt={user?.surname}>{user?.surname?.[0]}</ColoredAvatar>
        <PageHeaderText text={userName} />
      </Stack>
    </PageHeaderWrapper>
  );
};
export interface UserEditPageHeaderProps {
  user: User;
}

export default ProfileEditPageHeader;
